"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _core = require("@material-ui/core");
var _Fonts = require("../constants/Fonts");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var BorderColors = function BorderColors(colors) {
  var c = colors !== null && colors !== void 0 ? colors : _pittaModules.LightColors;
  return {
    Normal: "1px solid ".concat(c.primary["8"], "5A"),
    Manual: "1px solid ".concat(c.secondary["17"], "5A"),
    Event: "1px solid ".concat(c.secondary["11"], "5A"),
    Parking: "1px solid ".concat(c.primary["2"], "5A")
  };
};
var FontColors = function FontColors(colors) {
  var c = colors !== null && colors !== void 0 ? colors : _pittaModules.LightColors;
  return {
    Normal: _pittaModules.BlackvueLightColors.primary["7"],
    Manual: c.secondary["17"],
    Event: c.secondary["11"],
    Parking: c.primary["2"]
  };
};
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    fileType: {
      position: "relative",
      display: "flex",
      justifyContent: "center",
      borderRadius: 20,
      textTransform: "none",
      whiteSpace: "nowrap"
    },
    aiText: {
      position: "absolute",
      top: -6,
      right: -12
    },
    //@ts-ignore
    aiTextSvg: _objectSpread(_objectSpread({}, _Fonts.Fonts.Default.CaptionBold), {}, {
      fontSize: 11,
      lineHeight: "13px",
      fontFamily: "Roboto",
      fill: function fill(props) {
        return props.colors.primary["7"];
      },
      stroke: "white",
      strokeWidth: 4,
      strokeLinejoin: "round"
    })
  });
});
var FileType = function FileType(props) {
  var _t;
  var fileType = props.fileType,
    isAI = props.isAI,
    t = props.t,
    colors = props.colors;
  var classes = useStyle(_objectSpread(_objectSpread({}, props), {}, {
    colors: colors !== null && colors !== void 0 ? colors : _pittaModules.LightColors
  }));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.fileType
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "CaptionBold",
    htmlColor: FontColors(colors)[fileType !== null && fileType !== void 0 ? fileType : "Normal"]
  }, (_t = t === null || t === void 0 ? void 0 : t(fileType)) !== null && _t !== void 0 ? _t : fileType), isAI && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.aiText
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react.default.createElement("text", {
    y: "10",
    className: classes.aiTextSvg,
    paintOrder: "stroke"
  }, "AI"))));
};
var _default = FileType;
exports.default = _default;